/***od线 */
import { Utils } from "@/plugin/gis-viewer/Utils";
import { IODDataParams } from "@/types/map";
import Axios from "axios";
import { loadModules } from "esri-loader";
import echartsLayer from "./echartsLayer";
declare let BMap: any;
export class MigrateChartCom {
  private static intances: Map<string, any>;
  private view!: any;
  private echartlayer: any;
  private level: any;

  private constructor(view: any) {
    this.view = view;
  }

  public static getInstance(view: any) {
    let id = view.getContainer().id;
    if (!MigrateChartCom.intances) {
      MigrateChartCom.intances = new Map();
    }
    let intance = MigrateChartCom.intances.get(id);
    if (!intance) {
      intance = new MigrateChartCom(view);
      MigrateChartCom.intances.set(id, intance);
    }
    return intance;
  }

  public static destroy() {
    (MigrateChartCom.intances as any) = null;
  }

  // 隐藏并清除迁徙图
  public async hideMigrateChart() {
    this._clear();
  }

  // 传入迁徙数据显示迁徙图
  public async showODChartByData(params: IODDataParams) {
    this._clear();
    // 解析参数
    if (params == undefined || params == null) {
      return;
    }
    const showCenter = params.showCenter === true;
    const pointData = JSON.parse(JSON.stringify(params.pointData)) || []; //数据深拷贝
    const datas = JSON.parse(JSON.stringify(params.datas)); //数据深拷贝
    const showLabel = params.showLabel;
    const showPointLabel = params.showPointLabel;
    const tooltipStatus = params.tooltipStatus ? params.tooltipStatus : false;
    const tooltipStyle = params.tooltipStyle ? params.tooltipStyle : {};
    const lineStyle = params.lineStyle;
    const textStyle = params.textStyle;
    const effectStyle = params.effectStyle;

    const geoCoordMap = new Map<string, [number, number]>();
    const geopoints = new Array<any>();
    pointData.forEach((p: any, index: number) => {
      // 经纬度转换，地理坐标转投影
      const point = new BMap.Point(p.value[0], p.value[1]);
      console.log(p.value[2], "层级");

      this.level = p.value[2] || 11;
      geopoints.push(point);
      p.value[0] = point.lng;
      p.value[1] = point.lat;
      geoCoordMap.set(p.name, [point.lng, point.lat]);
    });

    const ODData: any[] = []; //od线数据

    datas.forEach((line: any) => {
      let fromCoord = geoCoordMap.get(line.from);
      let toCoord = geoCoordMap.get(line.to);
      ODData.push({
        fromName: line.from,
        toName: line.to,
        coords: [fromCoord, toCoord],
        value: line.value,
        style: line.style,
      });
    });

    if (showCenter) {
      let center = new BMap.Point(geopoints[0].lng, geopoints[0].lat);
      this.view.centerAndZoom(center, this.level);
      // this.view.panTo(
      //   {
      //     target: geopoints,
      //   },
      //   {
      //     animate: true,
      //     duration: 1000,
      //     easing: "ease",
      //   }
      // );
    }

    const series = [
      {
        name: "底线",
        type: "lines",
        coordinateSystem: "bmap",
        zlevel: 1,
        z: 1,
        //silent: true,
        label: { show: showLabel, position: "middle", fontSize: 30 },
        lineStyle: {
          normal: {
            color: (val: any) => {
              return val.data.style?.color || "blue";
            },
            // color: (val: any) => {
            //   let data = {
            //     type: "linear",
            //     x: 0,
            //     y: 0,
            //     x2: 0,
            //     y2: 1,
            //     colorStops: [
            //       {
            //         offset: 1,
            //         color: "rgba(0,220,245)", // 0% 处的颜色
            //       },
            //       {
            //         offset: 0.5,
            //         color: "#ff6100", // 0% 处的颜色
            //       },
            //       {
            //         offset: 0,
            //         color: "red", // 100% 处的颜色
            //       },
            //     ],
            //     global: false, // 缺省为 false
            //   };
            //   return data;
            //   // return val.data.style?.color || "blue";
            // },
            width: 1,
            opacity: 1,
            curveness: 0.2,
            ...lineStyle,
          },
        },
        effect: {
          show: false,
        },
        // blendMode: "lighter",
        data: ODData,
      },
      {
        name: "线动画",
        type: "lines",
        coordinateSystem: "bmap",
        zlevel: 2,
        z: 2,
        //silent: true,
        lineStyle: {
          normal: {
            color: (val: any) => {
              return val.data.style?.color || "blue";
            },
            curveness: 0.2,
            ...lineStyle,
            width: 0,
            opacity: 0,
          },
        },
        effect: {
          show: true,
          period: 6,
          trailLength: 0.7,
          // color: "#76fbfd",
          symbolSize: 8,
          symbol: "circle",
          ...effectStyle,
        },
        data: ODData,
      },
      {
        name: "动态点",
        type: "effectScatter",
        coordinateSystem: "bmap",
        zlevel: 2,
        rippleEffect: {
          brushType: "stroke",
          scale: 1.4,
          number: 1,
        },
        label: {
          normal: {
            show: showPointLabel,
            position: "right",
            formatter: "{b}",
            fontSize: 15,
            textBorderColor: "yellow",
            textBorderWidth: 0,
            fontFamily: "serif",
            ...textStyle,
          },
        },
        symbolSize: (val: any) => {
          return val[3] || 8;
        },
        itemStyle: {
          normal: {
            color: (val: any) => {
              return val.data.style?.color || "red";
            },
            opacity: 1,
          },
        },
        data: pointData,
      },
    ];

    this.echartlayer = new echartsLayer(this.view);
    var option = {
      animation: false, // 禁用动画效果
      tooltip: {
        show: tooltipStatus,
        trigger: "item",
        formatter: "{b}",
        position: tooltipStyle.position ? tooltipStyle.position : "top",
        backgroundColor: tooltipStyle.backgroundColor ? tooltipStyle.backgroundColor : "rgba(0,0,0,0.4)",
        textStyle: {
          color: tooltipStyle.color ? tooltipStyle.color : "#fff",
          fontSize: tooltipStyle.fontSize ? tooltipStyle.fontSize : "14",
          lineHeight: tooltipStyle.lineHeight ? tooltipStyle.lineHeight : "14",
        },
      },
      series: series,
    };
    this.echartlayer.setChartOption(option);
  }

  private _clear() {
    if (this.echartlayer) {
      //this.view.map.remove(this.echartlayer);
      this.echartlayer.removeLayer();
      this.echartlayer = null;
    }
  }
}
